import(/* webpackMode: "eager" */ "/app/app/(text-pages)/page.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/img/icons/IconLinkedIn.svg");
;
import(/* webpackMode: "eager" */ "/app/public/img/profile/team-photo-dave.webp");
;
import(/* webpackMode: "eager" */ "/app/public/img/profile/team-photo-jennifer.webp");
;
import(/* webpackMode: "eager" */ "/app/public/img/profile/team-photo-jess.webp");
;
import(/* webpackMode: "eager" */ "/app/public/img/profile/team-photo-kevin-m.webp");
;
import(/* webpackMode: "eager" */ "/app/public/img/profile/team-photo-kevin.webp");
;
import(/* webpackMode: "eager" */ "/app/public/img/profile/team-photo-ray.webp");
;
import(/* webpackMode: "eager" */ "/app/public/img/profile/team-photo-shelby.webp");
